import { apiURL } from 'src/consumer/services'

/**
 * Public payout report viewer endpoint.
 * GET /api/nc/payout-reports/{invoiceId}/file
 *
 * @param {string} invoiceId - Payout invoice id from URL (e.g. /payout-report/{invoiceId})
 * @returns {Promise<Blob>} PDF blob on 200
 * @throws {Response} Throws the Response on !res.ok so caller can read res.status.
 */
export async function loadPayoutReportPdf(invoiceId) {
  const url = `${apiURL}/api/nc/payout-reports/${encodeURIComponent(invoiceId)}/file`
  const res = await fetch(url, { method: 'GET' })
  if (!res.ok) {
    throw res
  }
  return res.blob()
}
